/* eslint-env jest */
import {
  freeMagnetsBadge, freeMagnetsRow, isMagnetsOption, magnetsOptionLabel, FREE_MAGNETS_BADGE,
} from './packageCardOffer';

const magnets = { couponType: 'FREE_MAGNETS_WITH_FREE_SHIPPING', value: 0, expiresOn: '2026-10-24' };
const pct = { couponType: 'PERCENTAGE_WITH_FREE_SHIPPING', value: 20, expiresOn: '2026-10-24' };

describe('package card — free magnets tier (issue #5218)', () => {
  it('shows the badge only while the magnet tier is live', () => {
    expect(freeMagnetsBadge(magnets)).toBe(FREE_MAGNETS_BADGE);
    expect(freeMagnetsBadge(pct)).toBeNull();
    expect(freeMagnetsBadge(null)).toBeNull();
  });

  it('appends the checklist row with the deadline', () => {
    expect(freeMagnetsRow(magnets)).toBe('(2) FREE Photo Magnets — offer ends Saturday, October 24');
    expect(freeMagnetsRow({ ...magnets, expiresOn: null })).toBe('(2) FREE Photo Magnets');
    expect(freeMagnetsRow(pct)).toBeNull();
    expect(freeMagnetsRow(undefined)).toBeNull();
  });

  it('labels the a-la-carte Magnets option FREE with any package only while live', () => {
    expect(isMagnetsOption({ name: 'Magnets' })).toBe(true);
    expect(isMagnetsOption({ name: 'Photo Magnets' })).toBe(true);
    expect(isMagnetsOption({ name: 'Star Student' })).toBe(false);
    expect(magnetsOptionLabel({ name: 'Magnets' }, magnets)).toBe('FREE with any package');
    expect(magnetsOptionLabel({ name: 'Magnets' }, pct)).toBeNull();
    expect(magnetsOptionLabel({ name: 'Star Student' }, magnets)).toBeNull();
    expect(magnetsOptionLabel(null, magnets)).toBeNull();
  });
});
